import { Box, Stack, styled } from '@mui/material';
import { PoolLineClampTypography } from '@synergy/components-next';
import { PropsWithChildren, ReactElement } from 'react';

const Headline = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    maxWidth: 'calc(100% - 32px)',

    [theme.breakpoints.up('sm')]: {
        maxWidth: 568,
    },
}));

const Description = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    maxWidth: 'calc(100% - 32px)',
    fontWeight: 500,

    [theme.breakpoints.up('sm')]: {
        maxWidth: 520,
    },
}));

interface HeaderBannerContentProps {
    headline?: string;
    subtitle?: string;
}

export const HeaderBannerContent = (props: PropsWithChildren<HeaderBannerContentProps>): ReactElement => {
    const { headline, subtitle, children } = props;

    return (
        <Stack sx={{ gap: { sm: 1.5, xs: 1 } }}>
            <Headline>
                <PoolLineClampTypography variant="h2Uppercase" maxLines={2}>
                    {headline}
                </PoolLineClampTypography>
            </Headline>
            <Description>
                <PoolLineClampTypography
                    variant="h5"
                    maxLines={2}
                    component="span"
                    sx={{ letterSpacing: { xs: -0.2, sm: 0 }, fontWeight: 500 }}
                >
                    {subtitle}
                </PoolLineClampTypography>
            </Description>
            {children}
        </Stack>
    );
};
